module.exports = __webpack_public_path__ + "static/img/7.cdbe73a7.jpg";